import React from 'react';

const Loader = () => {

    return (
        <div className="contenido">
            <div className="spinner">
            </div>
            <i className="bi bi-music-note-beamed"></i>        
            </div>
    );
};

export default Loader;
